import { HTMLAttributes, useMemo } from "react";
import styled from "styled-components";
import {
  ContractViewModel,
  Role,
} from "../../contract/model/ContractViewModel";
import Header, { HeaderVariant } from "./Header";
import {
  useStaticBecomeMemberMenuItem,
  useFaqLinkItem,
  useAboutLinkItem,
  combineMenuItems,
} from "./HeaderObjects";
import { useAuthHeaderElements } from "./AuthHeaderElements";
import { useLocation } from "react-router";
import { IContractParams } from "../../contract/ContractParams";
import { getContractLoginCallbackPageLocation } from "../../contract/contract-type/ContractLoginCallbackPage";
import { createLocationPath } from "../../shared/utils/Location";

const StaticHeaderWrapper = styled.div`
  background-color: ${({ theme }) => theme.nafColor.signature.white};
  width: 100%;
  z-index: 2;
`;

export interface StaticHeaderProps
  extends Omit<HTMLAttributes<HTMLDivElement>, "role"> {
  contract?: ContractViewModel;
  role?: Role;
}

export default function StaticHeader({
  contract,
  role,
  ...props
}: StaticHeaderProps) {
  const location = useLocation();
  const loginUrl = useMemo(() => {
    if (!contract) return undefined;
    const token =
      "sellerToken" in contract ? contract.sellerToken : contract.buyerToken;
    const params: IContractParams = { token };
    return createLocationPath(
      getContractLoginCallbackPageLocation(location, params)
    );
  }, [location, contract]);
  const authHeaderProps = useAuthHeaderElements(loginUrl);
  const faqProps = useFaqLinkItem();
  const aboutProps = useAboutLinkItem();
  const becomeMember = useStaticBecomeMemberMenuItem();

  const elements = useMemo(() => {
    return combineMenuItems([
      ...authHeaderProps,
      aboutProps,
      faqProps,
      becomeMember,
    ]);
  }, [authHeaderProps, faqProps, aboutProps, becomeMember]);

  return (
    <StaticHeaderWrapper {...props}>
      <Header
        variant={HeaderVariant.Static}
        elements={elements}
        contract={contract}
        role={role}
      />
    </StaticHeaderWrapper>
  );
}
